module.exports = "/lucky-balls/img/brown-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/brown-ball.png
// module id = 96
// module chunks = 0